import {
  Component,
  computed,
  EventEmitter,
  inject,
  input,
  Output,
} from '@angular/core';
import { OrderAssessmentComponent } from '../order-assessment/order-assessment.component';
import {
  EligibilityAssessment,
  Order,
  OrderDocument,
  OrderDocumentType,
  OrderStatus,
} from '../../../../../models/order.model';
import { TabsModule } from 'primeng/tabs';
import { Customer } from '../../../../../models/customer.model';
import { PhoneFormatPipe } from '../../../../../../shared/pipes/format-phone.pipe';
import { DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-order-details-documents',
  imports: [OrderAssessmentComponent, TabsModule, DatePipe, ButtonModule],
  templateUrl: './order-details-documents.component.html',
})
export class OrderDetailsDocumentsComponent {
  order = input<Order | null>(null);
  eligibilityAssessment = input<EligibilityAssessment | null>(null);
  @Output() loadData = new EventEmitter<string>();

  private phoneFormatPipe = inject(PhoneFormatPipe);

  get customer(): Customer {
    return this.order()?.customer as Customer;
  }

  get documents(): any[] {
    return (this.order()?.documents ??
      this.order()?.documents ??
      []) as OrderDocument[];
  }

  get primaryEmail(): string {
    const c = this.customer;
    if (!c) return '-';

    const list = c.electronicAddresses ?? [];
    return list?.[0]?.address ?? '-';
  }

  get primaryPhone(): string {
    const c = this.customer;
    if (!c) return '-';

    const list = c.phones ?? [];
    if (list.length <= 0) return '-';

    const phone = list[0];
    const countryCode = phone!.countryCode;
    const phoneFormatted = this.phoneFormatPipe.transform(
      phone!.number,
      countryCode,
      { includeCountryCode: true },
    );
    return phoneFormatted;
  }

  reloadOrder(): void {
    if (this.order()) this.loadData.emit(this.order()!.id);
  }

  getDocumentNameByType(type: OrderDocumentType) {
    switch (type) {
      case OrderDocumentType.ProofOfAddress:
        return 'Comprovante de Residência';
      case OrderDocumentType.BankStatement:
        return 'Comprovante Bancário';
      case OrderDocumentType.FaceCapture:
        return 'Captura da Face';
      case OrderDocumentType.Passport:
        return 'Passaporte';
      default:
        return 'Documento';
    }
  }

  underReview = computed(() => {
    if (!this.order) return false;
    return this.order()!.status >= OrderStatus.UnderReview;
  });
}
